<template>
  <v-container fluid class="mt-12"
    ><v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("user.modulesbtn") }}</span>
    </v-tooltip>
    <v-snackbar dark v-model="snackbar.status">
      {{ snackbar.text }}
      <v-btn color="primary" @click="snackbar.status = false">
        {{ $t("user.closebtn") }}
      </v-btn>
    </v-snackbar>
    <v-container>
      <v-layout column>
        <v-card>
          <v-card-title
            class="primary white--text d-flex font-weight-bold justify-center text-center"
            >{{ $t("user.newUser") }}</v-card-title
          >

          <v-form dark ref="applicant" v-model="valid" lazy-validation>
            <v-card-text class="mt-12">
              <v-text-field
                prepend-icon="mdi-account"
                v-model="form.firstName"
                :label="$t('user.firstName')"
                :rules="requireRules"
              ></v-text-field>
              <v-text-field
                prepend-icon="mdi-account-outline"
                v-model="form.lastName"
                :label="$t('user.lastName')"
                :rules="requireRules"
              ></v-text-field>
              <v-text-field
                ref="email"
                prepend-icon="mdi-at"
                v-model="form.email"
                :label="$t('user.email')"
                :rules="emailRules"
              ></v-text-field>

              <v-select
                prepend-icon="mdi-alpha-m"
                filled
                v-model="form.isMetax"
                :label="$t('user.metaxuser')"
                :items="[
                  { name: $t('user.boolean.yes'), value: true },
                  { name: $t('user.boolean.no'), value: false }
                ]"
                item-text="name"
                item-value="value"
              ></v-select>

              <v-select
                prepend-icon="mdi-domain"
                filled
                v-model="form.plant"
                :label="$t('user.plant')"
                :items="plants"
                item-text="name"
                item-value="name"
                return-object=""
              ></v-select>
              <v-select
                v-model="form.role"
                :hint="$t('user.userLevel')"
                :items="roles"
                item-text="state"
                item-value="value"
                :label="$t('user.userLevel')"
                single-line
                persistent-hint
                :prepend-icon="
                  form.role && form.role.abbr
                    ? form.role.abbr
                    : 'mdi-account-circle'
                "
              ></v-select>
              <v-text-field
                v-model="form.password"
                :label="$t('user.password')"
                name="password"
                prepend-icon="mdi-lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passwordRules"
                :type="show1 ? 'text' : 'password'"
                :hint="this.$t('user.messages.password.hint')"
                counter
                @click:append="show1 = !show1"
              >
                <template slot="append-outer">
                  <v-btn color="primary" icon @click="copyToClipboard"
                    ><v-icon ref="password">mdi-content-copy</v-icon></v-btn
                  >
                </template>
              </v-text-field>
            </v-card-text>
          </v-form>
          <v-card-actions class="my-4">
            <v-btn
              width="280"
              x-large
              :disabled="!valid"
              class="mx-auto text-uppercase"
              @click="onSubmit"
              color="primary"
              >{{ $t("user.submit") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import roles from "@/settings/roles.js";
export default {
  pageTitle: "My Profile",
  data() {
    return {
      disabledPlants: true,
      valid: false,
      show1: true,
      show2: false,
      rules: {
        required: value => !!value || this.$t("user.messages.default"),
        min: v => v.length >= 6 || this.$t("user.messages.password.hint")
      },
      itemsSuperAdmin: [
        {
          state: this.$t("user.roles.super"),
          abbr: "mdi-shield-account",
          value: roles.superAdmin
        },
        {
          state: this.$t("user.roles.engineer"),
          abbr: "mdi-account-star",
          value: roles.engineer
        },
        {
          state: this.$t("user.roles.admin"),
          abbr: "mdi-account-tie",
          value: roles.admin
        },
        {
          state: this.$t("user.roles.supervisor"),
          abbr: "mdi-account-supervisor-circle",
          value: roles.supervisor
        },
        {
          state: this.$t("user.roles.reliability"),
          abbr: "mdi-account-cog",
          value: roles.reliability
        },
        {
          state: this.$t("user.roles.operator"),
          abbr: "mdi-account-circle",
          value: roles.operator
        }
      ],
      itemsAdmin: [
        {
          state: this.$t("user.roles.supervisor"),
          abbr: "mdi-account-supervisor-circle",
          value: roles.supervisor
        },
        {
          state: this.$t("user.roles.reliability"),
          abbr: "mdi-account-cog",
          value: roles.reliability
        },
        {
          state: this.$t("user.roles.operator"),
          abbr: "mdi-account-circle",
          value: roles.operator
        }
      ],
      itemsSupervisor: [
        {
          state: this.$t("user.roles.reliability"),
          abbr: "mdi-account-cog",
          value: roles.reliability
        },
        {
          state: this.$t("user.roles.operator"),
          abbr: "mdi-account-circle",
          value: roles.operator
        }
      ],
      rePassword: "",
      snackbar: {
        status: false,
        text: this.$t("user.messages.snackbar.successful")
      },
      plant: null,
      form: {
        password: Math.random()
          .toString(36)
          .slice(2)
      },
      requireRules: [
        v => (v && v.length >= 2) || this.$t("user.messages.default")
      ],
      emailRules: [
        v => !!v || this.$t("user.messages.email.required"),
        v => /.+@.+\..+/.test(v) || this.$t("user.messages.email.valid")
      ],
      passwordRules: [
        v => !!v || this.$t("user.messages.password.required"),
        v => (v && v.length >= 6) || this.$t("user.messages.password.valid")
      ],
      showAvatarPicker: false
    };
  },
  computed: {
    roles() {
      switch (this.user.role) {
        case "Super Admin":
          return this.itemsSuperAdmin;
        case "Admin":
          return this.itemsAdmin;
        case "Supervisor":
          return this.itemsSupervisor;
        default:
          return this.itemsSupervisor;
      }
    },
    ...mapState("auth", ["user"]),
    ...mapState("settings", ["plants"]),
    passwordConfirmationRule() {
      return () =>
        this.form.password === this.rePassword
          ? false
          : this.$t("user.messages.password.retype");
    }
  },
  methods: {
    copyToClipboard() {
      this.$clipboard(this.form.password);
      this.$dialog.notify.success("Copied!", {
        position: "top-right",
        timeout: 5000
      });
    },
    async onSubmit(ev) {
      ev.preventDefault();
      if (this.$refs.applicant.validate()) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        let formulario = {
          email: this.form.email,
          password: this.form.password,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          isMetax: this.form.isMetax,
          plant: this.form.plant.name,
          role: this.form.role
        };
        try {
          await this.$store.dispatch("auth/CREAR_USUARIO", formulario);
          this.$refs.applicant.reset();
          loading.close();
          this.$dialog.notify.success(
            this.$t("user.messages.snackbar.successful"),
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (err) {
          loading.close();
          this.$dialog.notify.error(err.message, {
            position: "top-right",
            timeout: 5000
          });
          setTimeout(() => {
            this.$refs.email.focus();
          });
        }
      }
    }
  }
};
</script>
